var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1097.92 1156.46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m779.5 402.08h200v200h-200z",
    fill: "#172b4d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(-605.08 -.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1384.58 602.77h100a100 100 0 0 1 0 200h-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1186.08 703.09a100 100 0 0 1 99.46-100.54l100-.55 1.09 200-100 .55a100 100 0 0 1 -100.55-99.46z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1284.58 203.77a100 100 0 0 1 100 100v100h-200v-100a100 100 0 0 1 100-100z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m884 .77a100 100 0 0 1 100 100v100h-200v-100a100 100 0 0 1 100-100z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1185.59 506a100 100 0 0 1 98.48-101.49l100-1.51 1.51 100a100 100 0 0 1 -200 3z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m984.58 200.77h200a100 100 0 0 1 -200 0z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1184.58 200.77h200a100 100 0 0 1 -200 0z",
    fill: "#fb6340"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m918.94 802.07h176.96v200h-176.96z",
    fill: "#f5365c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m884 299.27a100 100 0 0 1 0 200h-100v-100a100 100 0 0 1 100-100z",
    fill: "#5e72e4",
    fillRule: "evenodd",
    transform: "translate(-605.08 -.77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1502.41 803.06 1.15 200c-64.29.37-116.66-44.1-117-99.33s51.56-100.31 115.85-100.67z",
    fill: "#5e72e4",
    fillRule: "evenodd",
    transform: "translate(-605.08 -.77)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m579.5 0h200v200h-200z",
    fill: "#f5365c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m379.5 0h200v200h-200z",
    fill: "#11cdef"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m896.92 204h200v200h-200z",
    fill: "#f5365c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(-605.08 -.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1386.58 203.77h100a100 100 0 1 1 -100 100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e72e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1584.58 202.77a100 100 0 0 1 0-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1584.21 202.77v-200a100 100 0 0 1 0 200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1497.29 803.05h102.35c56.53 0 102.36 44.78 102.36 100s-45.83 100-102.36 100h-102.35z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1703 800.05c-65.4 0-118.42-44.77-118.42-100s53-100 118.42-100z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1602 403.77h100v200h-100a100 100 0 0 1 0-200z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784 199.77h200a100 100 0 0 1 -200 0z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1150 570.81c-1.48 55.21 36.79 101 85.48 102.33 1.52-55.21-36.79-101.02-85.48-102.33z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1385.37 402.85a100 100 0 0 0 -93.37 106.2 100 100 0 0 0 93.37-106.2z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1365.33 1033.46a100 100 0 0 1 -123.69 68.54 100 100 0 0 1 123.69-68.54z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1384.91.77a100 100 0 0 1 100 100 100 100 0 0 1 -100-100z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1384.91 202.77c55.23 0 100-45.67 100-102-55.23 0-100 45.67-100 102z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1686.58 185.27a100 100 0 0 1 -100 100 100 100 0 0 1 100-100z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.34 76.26a100 100 0 0 1 -100 100 100 100 0 0 1 100-100z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070.34 502.27v-200c63.64 0 115.24 44.78 115.24 100s-51.58 100-115.24 100z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1171.2 250.77a100 100 0 0 1 -173.24 0 100 100 0 0 1 173.24 0z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.56 679.35a100 100 0 0 1 129.79-114.75 100 100 0 0 1 -129.79 114.75z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m881 352.27a50 50 0 1 1 -50 50 50 50 0 0 1 50-50z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1149.34 939.88a29 29 0 1 1 -29 29 29 29 0 0 1 29-29z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1178.34 741.69a50 50 0 1 1 -50 50 50 50 0 0 1 50-50z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m998 502.85a50 50 0 1 1 -50 50 50 50 0 0 1 50-50z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134.58 461.62a50 50 0 1 1 -50 50 50 50 0 0 1 50-50z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1597.27 853.05a50 50 0 1 1 -50 50 50 50 0 0 1 50-50z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.59 61.65a26.51 26.51 0 1 1 -26.51 26.51 26.5 26.5 0 0 1 26.51-26.51z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1384.58 200.77a100 100 0 0 1 -100 100 100 100 0 0 1 100-100zm-200 200a100 100 0 0 1 100-100 100 100 0 0 1 -100 100zm100-100a100 100 0 0 1 -100-100 100 100 0 0 1 100 100zm0 0a100 100 0 0 1 100 100 100 100 0 0 1 -100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1421.2 1039.88a100 100 0 0 1 78.92 117.35 100 100 0 0 1 -78.92-117.35z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1612.5 452.85a50 50 0 1 1 -50 50 50 50 0 0 1 50-50z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.08 265.6a54 54 0 0 1 -54 54 54 54 0 0 1 54-54zm-108 108a54 54 0 0 1 54-54 54 54 0 0 1 -53.96 53.95zm54-54a54 54 0 0 1 -54-54 54 54 0 0 1 54.02 53.98zm0 0a54 54 0 0 1 54 54 54 54 0 0 1 -53.98-54.02z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1120.34 668.16a100 100 0 0 1 -100 100 100 100 0 0 1 100-100zm-200 200a100 100 0 0 1 100-100 100 100 0 0 1 -100 100zm100-100a100 100 0 0 1 -100-100 100 100 0 0 1 100 100zm0 0a100 100 0 0 1 100 100 100 100 0 0 1 -100-100z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1020.34 741.65a26.51 26.51 0 1 1 -26.5 26.51 26.51 26.51 0 0 1 26.5-26.51z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1315.08 630a26.51 26.51 0 1 1 -26.5 26.51 26.51 26.51 0 0 1 26.5-26.51z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1398.9 976.55a26.51 26.51 0 1 1 -26.51 26.5 26.5 26.5 0 0 1 26.51-26.5z",
    fill: "#172b4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.dda5054f8a577430011813f7cb57ae56.svg";
export { ForwardRef as ReactComponent };